<div class="sms form-frame">
  <app-logo></app-logo>

  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="form-frame__body">
    <h2
      class="form-frame__body-title">
      {{'SMS_PAGE.TITLE' | translate}}
    </h2>
    <p
      class="form-frame__body-description">
      {{'SMS_PAGE.DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">

      <div class="input-block">
        <input
          formControlName="smsCode"
          mask="000000"
          inputmode="numeric"
          id="smsCode"
          class="input"
          type="text"
          placeholder=" ">
        <label
          for="smsCode"
          class="placeholder">
          {{'SMS_PAGE.SMS_CODE' | translate}}
        </label>
      </div>

      <button
        [disabled]="form.invalid"
        type="submit"
        class="btn btn-accent btn-send">
        {{'SMS_PAGE.SEND' | translate}}
      </button>
    </div>

    <p
      *ngIf="!isEnableResend"
      class="sms__description">
      {{'SMS_PAGE.RESEND' | translate}} {{count}} {{second}}
    </p>

    <button
      *ngIf="isEnableResend"
      (click)="resendSMS()"
      type="button"
      class="btn btn-link">
      {{'SMS_PAGE.NOT_SMS' | translate}}
    </button>
  </form>

  <app-lang-select></app-lang-select>
</div>
